import authorizedAPIInstance from '@/api/authorizedAPI';
import type { MaterialMatchSummary } from '../utils/match-maker.types';
import { formatAPIError } from '@/utils/helpers';

export const fetchMaterialMatchSummaryDetail =
  async (): Promise<MaterialMatchSummary> => {
    try {
      const { data } = await authorizedAPIInstance.get<MaterialMatchSummary>(
        `/api/materials/match-summary`
      );

      return data;
    } catch (error) {
      throw formatAPIError(error);
    }
  };
